import { gql } from '@apollo/client'

const CreateEndorsementInvitation = gql`
  mutation CreateEndorsementInvitation(
    $input: CreateEndorsementInvitationInput!
  ) {
    createEndorsementInvitation(input: $input) {
      success
      message
    }
  }
`

const GetCoachFacilitiesAndEndorsements = gql`
  query CoachFacilitiesAndEndorsements {
    currentUser {
      attributes {
        ... on Coach {
          facilities {
            id
            name
          }
        }
      }
    }
    coachEndorsements {
      id
      status
      name
      email
      title
      expiredAt
      facility {
        name
      }
    }
  }
`

export { CreateEndorsementInvitation, GetCoachFacilitiesAndEndorsements }
